import { User } from '@auth0/auth0-react';

export enum FeatureFlag {
  ReltimeSensogramEnabledDepr = 'realtime_sensorgram',
  RunExperimentEnabled = 'run_experiment',
  RoleAryballe = 'role_aryballe',
  FullSensogramEnabled = 'full_sensorgram',
  AANonAggregatedPeptidesAccessEnabled = 'aa_access_to_nonaggregated_peptides',
  AAChemicalFamiliesAccessEnabled = 'aa_access_to_chemical_families',
  AAHumidityCompensationAccessEnabled = 'aa_humidity_compensation',
  AAChemicalCalibrationAccessEnabled = 'aa_access_to_chemical_calibration',
  AADeleteRunsEnabled = 'aa_delete_runs',
  AALightViewQualityControl = 'aa_light_view_quality_control',
  AASensorIntegrityControlEnabled = 'aa_access_to_sensor_integrity_control',
  AAReferencePcaAccessEnabled = 'aa_access_to_reference_pca',
}

export enum SaasAccessType {
  Authorized = 'authorized',
  Expired = 'expired',
}

export interface UserClaimsWithTSDB extends User {
  tsdb_url: string;
  tsdb_token: string;
  tsdb_org: string;
  main_tsdb_name: string;
  tsdb_refs: string[];
  feature_flags: FeatureFlag[];
  saas_access: SaasAccessType | undefined;
  saas_exp_timestamp: number | undefined;
}
